import { Component } from "@angular/core";
import { SafeHarborPlans } from "client/app/domains/SafeHarborPlans";

@Component({
  selector: 'app-safe-harbor',
  templateUrl: './safeHarbor.component.html',
  styleUrls: ['./safeHarbor.component.less'],
  standalone: false
})
export class SafeHarborComponent {
  public safeHarborPlans: SafeHarborPlans[];
  public safeHarborEffectiveDate: string;
  public safeHarborReleaseDate: string;
  dontShowStep1 = false;
  dontShowStep2 = true;

  childEventClicked(shSelected: SafeHarborPlans[]) {
    if (shSelected.length > 0) {
      this.safeHarborPlans = shSelected;
      this.dontShowStep1 = true;
      this.dontShowStep2 = false;
    }
  }

  efectiveDateClicked(shEffectiveDate: string) {
    this.safeHarborEffectiveDate = shEffectiveDate;
  }

  releaseDateClicked(shReleaseDate: string) {
    this.safeHarborReleaseDate = shReleaseDate;
  }

  backButtonClicked(back: boolean) {
    if (back) {
      this.dontShowStep1 = false;
      this.dontShowStep2 = true;
    }
  }

  navigateToStep2(shSelected: SafeHarborPlans[]) {
    this.safeHarborPlans = shSelected;
    this.dontShowStep1 = true;
    this.dontShowStep2 = false;
  }

}